import styled from 'styled-components';
import { FileDropzone } from './components';

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 400px;
`;

export const ImageContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const StyledFileDropzone = styled(FileDropzone)`
	width: 200px;
	height: 150px;
	border-radius: 18px;
	overflow: hidden;

	img {
		width: 200px;
		height: 150px;
		object-fit: contain;
	}
`;

export const Fieldset = styled.div``;

export const Label = styled.label`
	display: block;
	text-transform: uppercase;
	font-size: 0.9rem;
	margin-bottom: 0.5rem;
`;

export const ErrorMessage = styled.label`
	color: red;
	width: 400px;
	display: block;
	font-size: 0.9rem;
	margin-bottom: 0.5rem;
`;
